{
  const isVariant = () => document.documentElement.classList.contains('ab-pdp-reviews');

  const scrollToReviews = (event) => {
    if (!isVariant()) return;

    const badge = event.target.closest?.(
      '.jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge'
    );
    if (!badge) return;

    const target =
      document.querySelector('#MainProductReviews') ||
      document.querySelector('.ab-pdp-reviews__widget .jdgm-rev-widg, .ab-pdp-reviews__widget .jdgm-review-widget, .ab-pdp-reviews__widget .jm-review-widget');

    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  document.addEventListener('click', scrollToReviews, true);
}
